import React from 'react';
import { retryLoading } from '~/util';
import { useHasFeatureFlag, useIsBreakpointDown } from '~/modules/common/hooks';
import { NotSupportedPage } from '~/modules/common/components';

const ResourceAssignmentDialog = React.lazy(() =>
  retryLoading(() => import('./ResourceAssignmentDialog'))
);

const ResourceAssignmentDialogWrapper = props => {
  const isMobile = useIsBreakpointDown('sm');
  const isPsaPraaResourceMatchingEnabled = useHasFeatureFlag({
    featureFlag: 'isPsaPraaResourceMatchingEnabled'
  });

  if (isMobile && isPsaPraaResourceMatchingEnabled) return <NotSupportedPage />;

  return <ResourceAssignmentDialog {...props} />;
};

ResourceAssignmentDialogWrapper.propTypes = {};

export default ResourceAssignmentDialogWrapper;
